import { useReactiveVar } from '@apollo/client';
import { Form, FormInstance, Spin } from 'antd';
import { isRutApiLoading } from 'apollo/cache';
import React, { FC } from 'react';
import PersonalInformation from 'views/PersonalInformation';
import DynamicForm from 'views/PurchaseIntentForm';

const onFinish = (firstForm: FormInstance) => {
  firstForm.submit();
};

const PurchaseInformationForm: FC = () => {
  const [formPurchaseIntent] = Form.useForm();

  const isLoading = useReactiveVar(isRutApiLoading);

  return (
    <Form
      name="carInformation"
      scrollToFirstError
      onFinish={() => onFinish(formPurchaseIntent)}
    >
      <div style={{ display: 'flex', gap: '15px', flexDirection: 'column' }}>
        <DynamicForm form={formPurchaseIntent} />
        <Spin spinning={isLoading}>
          <PersonalInformation form={formPurchaseIntent} />
        </Spin>
      </div>
    </Form>
  );
};

export default PurchaseInformationForm;
